<h1 mat-dialog-title class="dialog-header">
  <span class="title">
    {{ "view_value.create_group_baseline" | translate }}
  </span>
  <button mat-icon-button class="icon-close-btn" mat-dialog-close>
    <mat-icon>close</mat-icon>
  </button>
</h1>

<mat-dialog-content
  fxLayout="column"
  fxLayoutAlign="start stretch"
  fxLayoutGap="10px"
  class="dialog-content"
>
  <div
    [formGroup]="formData"
    fxLayout="row"
    fxLayoutAlign="start center"
    fxLayoutGap="10px"
  >
    <div class="mat-form-field-wrapper">
      <span>{{ "view_value.baseline_name" | translate }} :</span>
    </div>
    <mat-form-field class="example-chip-list" appearance="outline">
      <input
        matInput
        placeholder="{{ 'view_value.baseline_name' | translate }}"
        formControlName="name"
      />
    </mat-form-field>
  </div>
  <div
    [formGroup]="formData"
    fxLayout="column"
    fxLayoutAlign="start stretch"
    fxLayoutGap="10px"
  >
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
      {{ "view_value.baseline" | translate }}
    </div>
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
      <mat-form-field class="example-chip-list" appearance="outline">
        <mat-label>{{ "view_value.day_per_hour" | translate }}</mat-label>
        <!-- <input
          matInput
          placeholder="{{ 'view_value.day_per_hour' | translate }}"
          formControlName="setpoint_day"
        /> -->
        <input
          matInput
          type="text"
          inputmode="numeric"
          pattern="[0-9]*"
          (input)="onInput($event, 'setpoint_day')"
          placeholder="{{ 'view_value.day_per_hour' | translate }}"
          formControlName="setpoint_day"
        />
        <span matTextSuffix> kWh</span>
      </mat-form-field>
      <mat-form-field class="example-chip-list" appearance="outline">
        <mat-label>{{ "view_value.month_per_day" | translate }}</mat-label>
        <input
          matInput
          type="text"
          inputmode="numeric"
          pattern="[0-9]*"
          (input)="onInput($event, 'setpoint_month')"
          placeholder="{{ 'view_value.month_per_day' | translate }}"
          formControlName="setpoint_month"
        />
        <span matTextSuffix> kWh</span>
      </mat-form-field>
    </div>
  </div>
  <div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
      {{ "view_value.group_baseline" | translate }}:
    </div>
    <mat-form-field appearance="outline">
      <!-- <mat-label>{{ "view_value.group_baseline" | translate }}</mat-label> -->
      <mat-chip-grid #chipList aria-label="Meter list selection">
        <mat-chip
          *ngFor="let groupBaseline of groupBaselines"
          (removed)="remove(groupBaseline)"
        >
          {{ groupBaseline.name }}
          <button matChipRemove>
            <mat-icon>cancel</mat-icon>
          </button>
        </mat-chip>
        <input
          #groupBaselineInput
          [formControl]="groupBaselineCtrl"
          [matAutocomplete]="auto"
          [matChipInputFor]="chipList"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          (matChipInputTokenEnd)="add($event)"
        />
      </mat-chip-grid>
      <mat-autocomplete
        #auto="matAutocomplete"
        (optionSelected)="selected($event)"
      >
        <mat-option
          *ngFor="let fillGroupbaseline of filteredGroupBaseline | async"
          [value]="fillGroupbaseline"
        >
          {{ fillGroupbaseline.name }}
        </mat-option>
      </mat-autocomplete>
    </mat-form-field>
  </div>
  <div fxLayout="column" fxLayoutAlign="start stretch" fxLayoutGap="10px">
    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
      {{ "view_value.email" | translate }}:
    </div>
    <mat-form-field appearance="outline">
      <mat-chip-grid #emailChipList aria-label="Email list selection">
        <mat-chip *ngFor="let email of emails" (removed)="removeEmail(email)">
          {{ email }}

          <button matChipRemove>
            <mat-icon>cancel</mat-icon>
          </button>
        </mat-chip>
        <input
          [formControl]="emailCtrl"
          [matChipInputFor]="emailChipList"
          [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
          [matChipInputAddOnBlur]="true"
          (matChipInputTokenEnd)="addEmail($event)"
        />
      </mat-chip-grid>
    </mat-form-field>
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="dialog-actions">
  <button mat-stroked-button class="btn-primary" (click)="confirm()">
    {{ "view_value.confirm" | translate }}
  </button>
</mat-dialog-actions>
